exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tw[data-v-ebaedc54] {\n  font-family: inherit;\n  color: inherit;\n  line-height: inherit;\n}\n.customfields .color-unset[data-v-ebaedc54] {\n  color: inherit;\n}\n.customfields .lineheight-unset[data-v-ebaedc54] {\n  line-height: inherit;\n}\n", ""]);

// exports
